import { FilterMatchMode } from "primereact/api";

/**
 * Filter config for the Checklist Review / Surveyor Submission tables. Kept in
 * its own module (free of component/service imports) so the Redux slice can use
 * it without transitively loading the table's cell components — those pull in
 * aws-amplify via the asset services, which fails to load under jest.
 *
 * Section is an exact-match dropdown — EQUALS, not CONTAINS, so a selected
 * section can't also match sections whose titles contain it as a substring.
 */
export const defaultReviewFilters = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    sectionTitle: { value: null, matchMode: FilterMatchMode.EQUALS },
    subsectionTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    questionText: { value: null, matchMode: FilterMatchMode.CONTAINS },
    response: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

export const reviewGlobalFilterFields = [
    "sectionTitle",
    "subsectionTitle",
    "questionText",
    "response",
];
